import { render, staticRenderFns } from "./foodList.vue?vue&type=template&id=2f33aad2&scoped=true&"
import script from "./foodList.vue?vue&type=script&lang=js&"
export * from "./foodList.vue?vue&type=script&lang=js&"
import style0 from "./foodList.vue?vue&type=style&index=0&id=2f33aad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33aad2",
  null
  
)

export default component.exports